import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogTitle,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { useState } from "react";
import { useCreateProject } from "./mutations";

export function CreateProjectDialog({
  open,
  onOpenChange,
}: {
  open: boolean;
  onOpenChange: (o: boolean) => void;
}) {
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const create = useCreateProject();

  const submit = async () => {
    await create.mutateAsync({ name, description: description || undefined });
    onOpenChange(false);
    setName("");
    setDescription("");
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogTitle>New project</DialogTitle>
        <DialogDescription>Projects isolate datasets, models, and API keys.</DialogDescription>
        <div className="mt-4 space-y-3">
          {/* biome-ignore lint/a11y/noLabelWithoutControl: Input is the control */}
          <label className="block">
            <span className="text-xs text-fg-muted">Name</span>
            <Input
              value={name}
              onChange={(e) => setName(e.target.value)}
              autoFocus
              placeholder="retail-demand"
            />
          </label>
          {/* biome-ignore lint/a11y/noLabelWithoutControl: Input is the control */}
          <label className="block">
            <span className="text-xs text-fg-muted">Description</span>
            <Input
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="optional"
            />
          </label>
        </div>
        <div className="mt-5 flex justify-end gap-2">
          <DialogClose asChild>
            <Button variant="default">Cancel</Button>
          </DialogClose>
          <Button variant="primary" disabled={!name || create.isPending} onClick={submit}>
            Create
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
